import { render, staticRenderFns } from "./FrotaDetalhes.vue?vue&type=template&id=598d2e64"
import script from "./FrotaDetalhes.vue?vue&type=script&lang=js"
export * from "./FrotaDetalhes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports